import {gql} from '@apollo/client';

import {isInaccessibleInfo} from 'auth/RequestAccess';
import ExcludeInaccessible from 'graphql-client/ExcludeInaccessible';
import {ProteinNamesQuery} from 'molbio/aa-sequences/util/__generated/ProteinNamesQuery';

type AaSequenceName = ProteinNamesQuery['aaSequences'][number];
type AccessibleAaSequenceName = ExcludeInaccessible<AaSequenceName>;

function isAccessibleAaSequence(protein: AaSequenceName): protein is AccessibleAaSequenceName {
  return !isInaccessibleInfo(protein);
}

export const AA_SEQUENCE_NAMES_QUERY = gql`
  query ProteinNamesQuery($ids: [StrictString!]!) @skipAudit @engComponent(name: MOLBIO) {
    aaSequences(ids: $ids) {
      ... on RegistryItemInterface {
        id
        displayLabel
      }
    }
  }
`;

export function getAccessibleAaSequenceNamesById(data: ProteinNamesQuery): Record<string, string> {
  const accessibleResults: Array<AccessibleAaSequenceName> = data.aaSequences.filter((protein) =>
    isAccessibleAaSequence(protein)
  );
  return accessibleResults.reduce<Record<string, string>>((acc, protein) => {
    acc[protein.id] = protein.displayLabel;
    return acc;
  }, {});
}
